
import { Button } from "@/components/ui/button";
import { FileText } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useState } from "react";
import { RepairEstimateDetails } from "./RepairEstimateDetails";

interface RepairEstimateButtonProps {
  vinLookupId: string;
}

export const RepairEstimateButton = ({ vinLookupId }: RepairEstimateButtonProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setOpen(true)}
      >
        <FileText className="h-4 w-4" />
        <span className="sr-only">View repair estimate</span>
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Repair Estimate Details</DialogTitle>
          </DialogHeader>
          <RepairEstimateDetails vinLookupId={vinLookupId} />
        </DialogContent>
      </Dialog>
    </>
  );
};
